import { useCurrentOverlay } from "shared/context/overlay/OverlayIDContext"
import { useEvent } from "shared/lib/useEvent"

import { DataTableOverlayViewProps } from "../ui/ProfileDeleteOverlayView"

export interface UseProfileDeleteOverlayViewModelProps {
  onSubmit: () => void
}

export function useProfileDeleteOverlayViewModel({
  onSubmit
}: UseProfileDeleteOverlayViewModelProps): DataTableOverlayViewProps {
  const { closeOverlay } = useCurrentOverlay()

  const handleOpenSubmitCodeOverlay = useEvent(() => {
    onSubmit()
    closeOverlay()
  })

  return {
    onClose: closeOverlay,
    onSubmit: handleOpenSubmitCodeOverlay
  }
}
